import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { message, Spin } from "antd";
import "./index.less";
import { PermissionEnum } from "../../const";
import batchDragPNG from "@/assets/img/joyspce/batchDrag.png";
import { batchMove } from "../../batchOperate/batch.move";
import { folderTypeEnum } from "../../config/permissions.config";
import events from "../../context/events";
import ReactDOM from "react-dom";
import { LoadingOutlined } from "@/utils/antdIcon";
import colors from "@/components/styles/colors";
import throttle from "lodash/throttle";
import ShareIcon from "../List/ShareIcon";

import { useNavigator } from "@/utils/NetworkCheck";
export enum dragModeEnum {
  single = "single",
  batch = "batch"
}
export enum dragTypeEnum {
  file = "file",
  folder = "folder",
  both = "both"
}
export enum DropTypeEnum {
  notAll = "notAll",
  notMe = "notMe",
  allow = "allow"
}
const dragState: {
  dragMode: null | dragModeEnum;
  dragType: null | dragTypeEnum;
  dragSelectedItems: Set<any>;
  dragIds: string[];
  dragItem: any;
  toFolderInfo: any;
  dragFrom: any;
  isProcessing: boolean;
} = {
  dragMode: null,
  dragType: null,
  dragItem: null,
  toFolderInfo: null,
  dragFrom: null,
  dragIds: [],
  isProcessing: false,
  dragSelectedItems: new Set()
};
let autoOpenTimer: any = null;
let movingTimer: any = null;

let toIdData: any = null;
const getContainer = () => {
  const node: any = document.getElementsByClassName("joyspace")?.[0];
  if (!node) {
    return null;
  }
  return node;
};
const refreshSelect = (isSetTimeout = true) => {
  console.log("refreshSelect");
  const doFresh = () => {
    if (dragState.toFolderInfo?.allowDrop === DropTypeEnum.allow) {
      toIdData.ele?.classList.add("drag-over-item");
    }
  };
  if (isSetTimeout) {
    setTimeout(() => {
      doFresh();
    }, 0);
    return;
  }
  doFresh();
};
const resetDragState = () => {
  dragState.toFolderInfo = null;
};
const resetAllDragState = () => {
  dragState.dragMode = null;
  dragState.dragItem = null;
  dragState.dragIds = [];
  dragState.dragType = null;
  dragState.toFolderInfo = null;
  dragState.dragFrom = null;
  dragState.isProcessing = false;
  removeDragingItems();
  clearTimeout(movingTimer);
  movingTimer = null;
};
const setDragSelectItem = (selecteItems: any) => {
  dragState.dragSelectedItems = selecteItems;
  //   handleDragImage(dragState.dragSelectedItems.size);
};
const getDragSelectItem = () => {
  return dragState.dragSelectedItems;
};

const getDragElem = () => {
  return document.getElementById("joyspace-drag-item");
};

const doDrag = (dragProps: { dragItem: any; e: any; dragImage: any; dragFrom?: any }) => {
  const { dragItem, e, dragFrom } = dragProps;
  e.preventDefault();
  // 处理中不可以拖拽
  if (dragState.isProcessing || !useNavigator.onLine) {
    // message.info("移动中请等待");
    return;
  }
  const check = doCheckDrag(dragItem);
  dragState.dragFrom = dragFrom;

  if (check) {
    if (dragState.dragMode === dragModeEnum.batch) {
      const items = document.querySelectorAll(".list-item-checked");
      items.forEach((item) => {
        item.classList.add("dragging-item");
      });
    } else {
      e.target.classList.add("dragging-item");
    }
    events.emit("joyspace-drag-event");
  } else {
    resetAllDragState();
    // e.preventDefault();
  }
  return check;
};

const removeDragingItems = () => {
  const items = document.querySelectorAll(".dragging-item");
  items.forEach((item) => {
    item.classList.remove("dragging-item");
    item.classList.remove("dragging-item-prevent");
  });
};
const setProcessingItem = () => {
  const items = document.querySelectorAll(".dragging-item");
  items.forEach((item) => {
    item.classList.add("dragging-item-prevent");
  });
};
const checkDropType = () => {
  const toFolderInfo = dragState.toFolderInfo;
  if (!toFolderInfo?.id) {
    toFolderInfo.allowDrop = DropTypeEnum.notAll;
    return;
  }
  toFolderInfo.allowDrop = DropTypeEnum.allow;
  // 含有文件不能拖到共享文件夹根目录，但是可以展开
  if (dragState.dragType !== dragTypeEnum.folder && toFolderInfo.toId === "tree-teamRoot") {
    toFolderInfo.allowDrop = DropTypeEnum.notMe;
    return;
  }
  // 如果我的文件从共享过来的就全部不能drop也不进行展开 还包含我的文件里面所有的文件夹
  if (
    (toFolderInfo.type === 8 || toFolderInfo.type === 8) &&
    (dragState.dragItem?.type === 12 || dragState.dragItem?.spaceType === 12)
  ) {
    toFolderInfo.allowDrop = DropTypeEnum.notAll;
    return;
  }
  // 如果共享且无权限不能drop也不进行展开
  if (
    toFolderInfo.toId !== "tree-teamRoot" &&
    toFolderInfo.type === 12 &&
    !toFolderInfo.permissions?.includes(PermissionEnum.FOLDER_EDIT)
  ) {
    toFolderInfo.allowDrop = DropTypeEnum.notAll;
    return;
  }

  // 自己不可以放到自己
  if (dragState.dragIds?.includes(toFolderInfo.id)) {
    toFolderInfo.allowDrop = DropTypeEnum.notAll;
    return;
  }

  // // 单个自己不可以放到自己的父
  // if (
  //   toFolderInfo.id === dragState.dragItem.parent ||
  //   (!dragState.dragItem.parent && toFolderInfo.id === "teamRoot") ||
  //   (dragState.dragItem.parent?.includes("$") && toFolderInfo.id === "myspace")
  // ) {
  //   toFolderInfo.allowDrop = DropTypeEnum.notMe;
  //   return;
  // }
};
const fileOrFolder = (item: any) => {
  if (!item) return null;
  return typeof item.page_type !== "undefined" ? dragTypeEnum.file : dragTypeEnum.folder;
};
const doCheckDrag = (dragItem: any) => {
  // eslint-disable-next-line no-debugger
  // debugger;
  let allowDrag = true;
  let dragMode = dragModeEnum.single;
  let dragType = null;
  let ids = [];
  // eslint-disable-next-line guard-for-in
  for (const item of dragState.dragSelectedItems) {
    ids.push(item.id);
    // @ts-ignore
    if (!(item?.permissions?.includes("FOLDER_MOVE") || item?.permissions?.includes("PAGE_MOVE"))) {
      allowDrag = false;
    }
    if (dragType && dragType !== fileOrFolder(item)) {
      dragType = dragTypeEnum.both;
    } else {
      dragType = fileOrFolder(item);
    }
    // @ts-ignore
    if (item.id === dragItem.id && dragState.dragSelectedItems.size > 1) {
      dragMode = dragModeEnum.batch;
    }
  }
  if (dragMode === dragModeEnum.batch) {
    if (allowDrag) {
      dragState.dragMode = dragModeEnum.batch;
      dragState.dragIds = ids;
      dragState.dragType = dragType;
      dragState.dragItem = dragItem;
      return true;
    }
    message.warning("存在无移动权限文件或文件夹");
    return false;
  } else {
    if (
      dragItem?.permissions?.includes("FOLDER_MOVE") ||
      dragItem?.permissions?.includes("PAGE_MOVE")
    ) {
      dragState.dragMode = dragModeEnum.single;
      dragState.dragItem = dragItem;
      dragState.dragIds = [dragItem.id];
      dragState.dragType = fileOrFolder(dragItem);
      return true;
    }
    message.warning("您暂无移动权限");
    return false;
  }
};

const getDragFlag: any = (ele: HTMLElement | null) => {
  if (!ele) return { id: null };
  try {
    const data = ele?.getAttribute("data-drag");
    if (data === "stop") return { id: null, ele };
    if (data === "stop-joyspace") return { id: null, type: "inner" };
    if (data) {
      return {
        ele,
        id: data
      };
    }
    // // @ts-ignore
    return getDragFlag(ele?.parentNode);
  } catch (error) {
    console.log(ele, "error111");
    return { id: null };
  }
};
const removeDragOver = () => {
  // @ts-ignore
  autoOpenTimer && clearTimeout(autoOpenTimer);
  const eles = document.getElementsByClassName(`drag-over-item`);
  for (let ele of eles) {
    ele?.classList.remove("drag-over-item");
  }
};
const removeDragOverDisable = () => {
  const eles = document.getElementsByClassName(`drag-over-item-disable`);
  for (let ele of eles) {
    ele?.classList.remove("drag-over-item-disable");
  }
};
function MoveDrag(props: { getFolderInfo: Function }) {
  const { getFolderInfo } = props;
  const [isProcessing, setIsProcessing] = useState(false);
  const [isDraging, setIsDraging] = useState(false);
  const [movePos, setMovePos] = useState<null | { top: string; left: string }>(null);
  const scrollNode = useRef<any>({});
  const scrollTimer = useRef<{ type: string; interval: any } | null>(null);
  useEffect(() => {
    if (isDraging) {
      scrollNode.current.right =
        document.getElementById("right-wrap") || document.getElementById("tableWrapper");
      scrollNode.current.left = document.getElementsByClassName("joyspace-nav-tree-space")?.[0];
    } else {
      scrollNode.current = {};
    }
  }, [isDraging]);
  useEffect(() => {
    events.on("right-autoScroll", doAutoScroll);
    return () => {
      events.off("right-autoScroll", doAutoScroll);
    };
  }, []);
  const doAutoScroll = (data: { scrollTop: number }) => {
    const { scrollTop } = data;
    console.log("doAutoScroll111", scrollTop);
    const scrollTopSet = scrollNode.current.right?.scrollTop - scrollTop;
    if (typeof scrollNode.current.right?.scrollTop !== "undefined") {
      scrollNode.current.right.scrollTop = scrollTopSet;
    }
  };
  const onDragDrop = useCallback(async (e) => {
    // 如果是文件拖拽不处理
    // if (e.dataTransfer.types && e.dataTransfer.types.includes("Files")) {
    //   return;
    // }
    if (!dragState.toFolderInfo?.id) return;
    if (dragState.toFolderInfo.allowDrop !== DropTypeEnum.allow) return;
    if (!dragState.dragItem) return;
    if (dragState.dragItem.page_type) {
      dragState.dragItem = {
        ...dragState.dragItem,
        type: dragState.dragItem.spaceType
      };
    }
    const isTeam = dragState.dragItem.type === 12 || dragState.dragItem.type === 3;

    const batchMoveToDtoList: any[] = [];
    if (dragState.dragMode === dragModeEnum.batch) {
      for (const item of dragState.dragSelectedItems) {
        batchMoveToDtoList.push({
          fromType: isTeam ? folderTypeEnum.SHARE : folderTypeEnum.MY,
          targetId: item.id,
          targetType: typeof item.page_type !== "undefined" ? 1 : 4
        });
      }
    } else {
      batchMoveToDtoList.push({
        fromType: isTeam ? folderTypeEnum.SHARE : folderTypeEnum.MY,
        targetId: dragState.dragItem.id,
        targetType: typeof dragState.dragItem.page_type !== "undefined" ? 1 : 4
      });
    }
    if (batchMoveToDtoList.length < 1) return;
    let parentId = dragState.dragItem.parent || dragState.dragItem.space_category_id;
    parentId = parentId ? (parentId.includes("$") ? "myspace" : parentId) : "teamRoot";
    const from = dragState.dragItem; // 目前from还必须是当前选中移动的元素
    // 解决移动到我的文件夹传参不正常问题
    if (dragState.toFolderInfo.id === "myspace") {
      dragState.toFolderInfo = { ...dragState.toFolderInfo, id: "root" };
    }
    batchMove({
      from,
      to: dragState.toFolderInfo,
      isTeam,
      originId: parentId,
      batchMoveToDtoList,
      isDrag: true,
      setData: (data: any) => {
        if (dragState.dragFrom === "table") {
          events.emit("table-setData", data);
        }
        if (dragState.dragFrom === "card") {
          events.emit("card-setData", data);
        }
      },
      callback: () => {
        resetAllDragState();
        setIsProcessing(false);
      },
      onOK: () => {
        movingTimer = setTimeout(() => {
          setIsProcessing(true);
        }, 500);
      },
      onCancel: () => {
        resetAllDragState();
        setIsProcessing(false);
      }
    });
    dragState.isProcessing = true;
    setProcessingItem();
  }, []);
  const checkScroll = (data: { e: any; dom: any; key: string }) => {
    const { e, dom, key } = data;
    if (!dom) return false;
    const domRect = dom?.getBoundingClientRect();

    if (domRect && domRect.x < e.x && e.x < domRect.width + domRect.x) {
      //   console.log(
      //     "checkScrolled位置：top",
      //     e.y,
      //     domRect.y - 50,
      //     domRect.y,
      //     domRect.y - 50 < e.y && e.y < domRect.y + 0,
      //     scrollTimer.current?.type
      //   );
      if (domRect.y - 50 < e.y && e.y < domRect.y + 0) {
        if (scrollTimer.current?.type !== key + "-top" || !scrollTimer.current) {
          scrollTimer.current?.interval && clearInterval(scrollTimer.current?.interval);
          const interval = setInterval(() => {
            events.emit(key + "-autoScroll", { scrollTop: 30 });
          }, 50);
          scrollTimer.current = {
            type: key + "-top",
            interval
          };
        }
        return true;
      }
      //   console.log(
      //     "checkScrolled位置：bottom",
      //     e.y,
      //     domRect.y + domRect.height - 55,
      //     domRect.y + domRect.height + 1,
      //     domRect.y + domRect.height - 55 < e.y && e.y < domRect.y + domRect.height + 1,
      //     scrollTimer.current?.type
      //   );
      if (domRect.y + domRect.height - 55 < e.y && e.y < domRect.y + domRect.height + 1) {
        if (scrollTimer.current?.type !== key + "-bottom" || !scrollTimer.current) {
          scrollTimer.current?.interval && clearInterval(scrollTimer.current?.interval);
          const interval = setInterval(() => {
            events.emit(key + "-autoScroll", { scrollTop: -30 });
          }, 50);
          scrollTimer.current = {
            type: key + "-bottom",
            interval
          };
        }
        return true;
      }
    }
    return false;
  };
  const handleAutoScroll = useCallback((e) => {
    if (!e) return;
    let checkScrolled = false;

    checkScrolled = checkScroll({
      e,
      dom: scrollNode.current.left,
      key: "tree"
    });
    // console.log(checkScrolled, "checkScrolled111");
    if (checkScrolled) return;
    checkScrolled = checkScroll({
      e,
      dom: scrollNode.current.right,
      key: "right"
    });

    // console.log(checkScrolled, "checkScrolled222");
    if (checkScrolled) return;
    if (scrollTimer.current) {
      //   console.log(checkScrolled, "checkScrolled333");
      scrollTimer.current.interval && clearInterval(scrollTimer.current.interval);
      scrollTimer.current = null;
    }
  }, []);

  const onDragOver = useCallback(
    async (e) => {
      const dragElem = getDragElem();
      if (!dragElem) return;
      const containerRect = getContainer()?.getBoundingClientRect();
      const dragElemRect = dragElem.getBoundingClientRect();
      const x = e.x - containerRect.x > 0 ? e.x - containerRect.x : 0;
      const y = e.y - containerRect.y > 0 ? e.y - containerRect.y : 0;
      const leftPos =
        x > containerRect.width - dragElemRect.width ? containerRect.width - dragElemRect.width : x;
      //   dragElem.style.left = leftPos + "px";
      const topPos =
        y > containerRect.height - dragElemRect.height
          ? containerRect.height - dragElemRect.height
          : y;
      //   dragElem.style.top = topPos + "px";
      setMovePos({ top: topPos + "px", left: leftPos + "px" });
      handleAutoScroll({ x: leftPos + containerRect.x, y: topPos + containerRect.y });
      toIdData = getDragFlag(e.target);
      if (toIdData?.id) {
        const toId = toIdData.id;
        if (dragState.toFolderInfo?.toId !== toId) {
          const id = toId.includes("tree-") ? toId.split("tree-")[1] : toId;
          const info = await getFolderInfo(id);
          dragState.toFolderInfo = { ...info, toId };
          checkDropType();
          removeDragOver();
          removeDragOverDisable();
          if (
            toId.includes("tree-") &&
            toIdData.ele.classList.contains("ant-tree-treenode-switcher-close") &&
            dragState.toFolderInfo?.allowDrop !== DropTypeEnum.notAll
          ) {
            autoOpenTimer = setTimeout(() => {
              toIdData?.ele.querySelector(".ant-tree-switcher")?.click();
              refreshSelect(false);
              // message.info("open");
            }, 1.5 * 1000);
          }
        }
        e.preventDefault();
        e.stopPropagation();
        if (dragState.toFolderInfo?.allowDrop === DropTypeEnum.allow) {
          toIdData.ele?.classList.add("drag-over-item");
        }
        if (dragState.toFolderInfo?.allowDrop !== DropTypeEnum.allow) {
          if (toIdData.ele) {
            toIdData.ele.classList.add("drag-over-item-disable");
          }
        }
      } else {
        removeDragOver();
        dragState.toFolderInfo = null;
        if (toIdData.ele) {
          removeDragOverDisable();
          toIdData.ele.classList.add("drag-over-item-disable");
        } else {
          removeDragOverDisable();
        }
      }
      e.stopPropagation();
    },
    [getFolderInfo, handleAutoScroll]
  );
  const handleMouseMove = throttle((e) => {
    onDragOver(e);
  }, 20);
  const doEndDrag = () => {
    if (!dragState.isProcessing) {
      resetAllDragState();
    }
    removeDragOver();
    removeDragOverDisable();
    setIsDraging(false);
    setMovePos(null);
    if (scrollTimer.current) {
      scrollTimer.current.interval && clearInterval(scrollTimer.current.interval);
      scrollTimer.current = null;
    }
    events.off("tree-loadData", refreshSelect);
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
  const handleMouseUp = (e: any) => {
    e.stopPropagation();
    e.stopImmediatePropagation();
    try {
      onDragDrop(e);
      doEndDrag();
    } catch {
      resetAllDragState();
      setIsProcessing(false);
      setIsDraging(false);
      setMovePos(null);
    }
  };

  const dragListener = useCallback(() => {
    if (isDraging) return;
    setIsDraging(true);
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    events.off("tree-loadData", refreshSelect);
    events.on("tree-loadData", refreshSelect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDraging]);
  useEffect(() => {
    const node = getContainer();
    if (!node) {
      return;
    }
    node.setAttribute("data-drag", "stop-joyspace");
    events.on("joyspace-drag-event", dragListener);
    return () => {
      events.off("joyspace-drag-event", dragListener);
    };
  }, [dragListener]);
  const DragItem = useMemo(() => {
    if (!isDraging) return null;
    const dragItem = dragState.dragItem;
    if (!dragItem) return null;
    return (
      <div
        id="joyspace-drag-item"
        style={{
          left: movePos?.left || 0,
          top: movePos?.top || 0,
          visibility: !movePos ? "hidden" : "visible"
        }}
      >
        {dragState.dragMode === dragModeEnum.batch ? (
          <>
            <span className="batch-img">
              <img src={batchDragPNG} />
            </span>
            <span className="name"> 共{dragState.dragSelectedItems.size}个对象</span>
          </>
        ) : (
          <>
            <ShareIcon
              isShared={dragItem.type === 3 ? true : dragItem.isShared}
              imgUrl={dragItem.icon_url}
            />
            <span className="name">{dragItem.name || "无标题"}</span>
          </>
        )}
      </div>
    );
  }, [isDraging, movePos]);
  return (
    <>
      {DragItem}
      {isProcessing &&
        ReactDOM.createPortal(
          <div id="joyspace-moving-info">
            <div className="info">
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 16, color: colors.primary2 }} />}
              />
              移动中
            </div>
          </div>,
          document.getElementById("root") || document.body
        )}
    </>
  );
}
export default MoveDrag;
export { dragState, setDragSelectItem, getDragSelectItem, doDrag };
